import {gql} from '@apollo/client';

export const BATCH_SAVE_SORTER_PLAN_CHUTES = gql`
    mutation BatchSaveSorterPlanChutes($sorterPlanId: Long!, $chutes: [SorterPlanChuteInput!]!, $operateType: Int!, $isDropBag: Boolean!, $printCount: Int!, $ppmodBagContainerId: Long, $isUseBatch: Boolean) {
        batchSaveSorterPlanChutes(sorterPlanId: $sorterPlanId, chutes: $chutes, operateType: $operateType, isDropBag: $isDropBag, printCount: $printCount, ppmodBagContainerId: $ppmodBagContainerId, isUseBatch: $isUseBatch)
    }
`;


